'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _decisivUiUtils = require('decisiv-ui-utils');

var _decisivIconixReact = require('decisiv-iconix-react');

var _decisivIconixReact2 = _interopRequireDefault(_decisivIconixReact);

var _childrenWithDefaultModifiers = require('../../utils/childrenWithDefaultModifiers');

var _childrenWithDefaultModifiers2 = _interopRequireDefault(_childrenWithDefaultModifiers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifierConfig = {
  danger: function danger(_ref) {
    var theme = _ref.theme;
    return 'background-color: ' + theme.colors.status.danger + ';';
  },

  info: function info(_ref2) {
    var theme = _ref2.theme;
    return 'background-color: ' + theme.colors.status.info + ';';
  },

  round: function round() {
    return 'border-radius: 50%;';
  },

  secondary: function secondary(_ref3) {
    var theme = _ref3.theme;
    return 'background-color: ' + theme.colors.base.chrome500 + ';';
  },

  success: function success(_ref4) {
    var theme = _ref4.theme;
    return 'background-color: ' + theme.colors.status.success + ';';
  },

  warning: function warning(_ref5) {
    var theme = _ref5.theme;
    return 'background-color: ' + theme.colors.status.warning + ';';
  }
};

var styles = function styles(_ref6) {
  var theme = _ref6.theme;
  return '\n  align-items: center;\n  background-color: ' + theme.colors.base.chrome200 + ';\n  border-radius: ' + theme.dimensions.borderRadius + ';\n  display: flex;\n  height: ' + (0, _decisivUiUtils.px2rem)(30) + ';\n  justify-content: center;\n  width: ' + (0, _decisivUiUtils.px2rem)(30) + ';\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome200: _propTypes2.default.string.isRequired,
      chrome500: _propTypes2.default.string.isRequired
    }).isRequired,
    status: _propTypes2.default.shape({
      danger: _propTypes2.default.string.isRequired,
      default: _propTypes2.default.string.isRequired,
      info: _propTypes2.default.string.isRequired,
      success: _propTypes2.default.string.isRequired,
      warning: _propTypes2.default.string.isRequired
    }).isRequired
  }),
  dimensions: _propTypes2.default.shape({
    borderRadius: _propTypes2.default.string.isRequired
  }).isRequired
};

var StyledBadge = (0, _decisivUiUtils.buildStyledComponent)('StyledBadge', _styledComponents2.default.div, styles, {
  modifierConfig: modifierConfig,
  themePropTypes: themePropTypes
});

function Badge(props) {
  var modifiersRequiringDefaults = ['danger', 'info', 'secondary', 'success', 'warning'];
  var defaultModifiers = ['chrome000'];
  var children = (0, _childrenWithDefaultModifiers2.default)(props, modifiersRequiringDefaults, defaultModifiers);

  return _react2.default.createElement(
    StyledBadge,
    props,
    children
  );
}

Badge.propTypes = {
  children: _propTypes2.default.node.isRequired
};

Badge.Icon = _decisivIconixReact2.default;

exports.default = Badge;


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/blocks/Badge/index.js
// module id = 1540
// module chunks = 2